import styled from 'styled-components';

export const MessageContainer = styled.div`
  margin-top: -30px;
  width: 80%;
  height: 50px;
  display: flex;
  flex-direction: column;
`;

export const Message = styled.h2`
  font-size: 1.2rem;
  line-height: 1rem;
  width: 80%;
  text-align: left;
  font-weight: bold;
  margin-top: 1rem;

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-height: 160px;
  overflow-y: scroll;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 1px;
`;
